// extracted by mini-css-extract-plugin
export var closeButton = "_mn-1";
export var closeX = "_mn-3";
export var container = "_mn-0";
export var image = "_mn-2";